import axios from 'axios'
import { Notification } from 'element-ui'

export async function getCountries(query, countries) {
  try {
    const res = await axios.get(`https://geo.services.exenzo.com/api/v1/search?location=${query}&countries=${countries}`)
    return res.data.data
  } catch (e) {
    Notification.error({ message: 'Something went wrong', dangerouslyUseHTMLString: true })
    throw e
  }
}
